export default __webpack_public_path__ + "static/media/slider_7-xs@1x.6b47950d.webp";